import styled from "@emotion/styled";
import { lodestarColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { FocusMode } from "../../../focusMode";
import { TextInputProps } from "../../../textinput/TextInput";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";

const { neutralDark20 } = lodestarColors;

interface DatePickerTextInputPlaceholderStyledProps extends InputFieldBaseProps {
    focusMode: FocusMode;
    isFocused: boolean;
    themeMode: RequiredThemeKeys;
    validationState: "error" | undefined;
    variant?: TextInputProps["variant"];
}

export const DatePickerTextInputPlaceholderStyled = styled("div")<DatePickerTextInputPlaceholderStyledProps>`
    position: absolute;
    box-sizing: border-box;
    outline: none;

    // This needs to show on top of the input, but not be clickable.
    z-index: 1;
    pointer-events: none;

    font-weight: ${({ themeMode }) => formInputTheme.fontWeight(themeMode)};
    font-size: ${({ themeMode, variant }) =>
        variant === "underline"
            ? formInputTheme.fontSize.underline(themeMode)
            : formInputTheme.fontSize.box(themeMode)};
    padding-top: ${({ themeMode, inputFieldHeight }) =>
        formInputTheme.placeholderTop[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)};
    padding-left: calc(2px + ${({ themeMode }) => formInputTheme.padding.default.rest(themeMode)}px);

    .sds__user-input {
        color: transparent;
    }

    .sds__format-placeholder {
        color: ${color("color--text--neutral--weak", neutralDark20)};
    }
`;
